// extracted by mini-css-extract-plugin
module.exports = {"goodToKnowWrapper":"GoodToKnow_goodToKnowWrapper__b4UBy","text":"GoodToKnow_text__rrTia","poweredBy":"GoodToKnow_poweredBy__YP7K4","disclaimer":"GoodToKnow_disclaimer__RWjv4"};